import { render, staticRenderFns } from "./ProviderDrives.vue?vue&type=template&id=b520b032&"
import script from "./ProviderDrives.vue?vue&type=script&lang=js&"
export * from "./ProviderDrives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports